// extracted by mini-css-extract-plugin
module.exports = {"copy-container":"CopyToClipboard_copy-container__1ASVo","tooltip":"CopyToClipboard_tooltip__2Mdez"};